// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"16714b3f","286":"5a1a9fd7","338":"cc904011","395":"4b144d14"}[chunkId] + ".css";
};